(function () {
  if (window.__erlyMotion) return;
  window.__erlyMotion = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.top < innerHeight - 30 && r.bottom > 0;
  }

  /* --- split headlines into masked words (luxury rise) --- */
  var SPLIT_SEL = '.ps__heading,.wib__heading,.hts__heading,.cmp__heading,.rvw__heading,.bnd__heading,.faq__heading,.fb__heading,.ph__title';
  function splitWords() {
    if (reduced) return;
    [].slice.call(document.querySelectorAll(SPLIT_SEL)).forEach(function (h) {
      if (h.classList.contains('e-split')) return;
      var idx = 0;
      function process(node) {
        [].slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            if (!n.textContent.trim()) return;
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (tok) {
              if (!tok) return;
              if (/^\s+$/.test(tok)) { frag.appendChild(document.createTextNode(tok)); return; }
              var w = document.createElement('span'); w.className = 'e-w';
              var wi = document.createElement('span'); wi.className = 'e-wi';
              wi.style.setProperty('--w-i', idx++);
              wi.textContent = tok;
              w.appendChild(wi); frag.appendChild(w);
            });
            node.replaceChild(frag, n);
          } else if (n.nodeType === 1 && n.tagName !== 'BR' && n.className.indexOf('e-w') === -1) {
            process(n);
          }
        });
      }
      try { process(h); h.classList.add('e-split'); } catch (e) { /* leave heading as-is */ }
    });
  }

  /* --- tag media frames for cinematic zoom-settle --- */
  var ZOOM_SEL = '.wib__media,.hts__media,.ps__item,.rvw__media,.ba__frame';
  function tagZoom() {
    if (reduced) return;
    [].slice.call(document.querySelectorAll(ZOOM_SEL)).forEach(function (el) { el.classList.add('e-zoom'); });
  }

  /* --- count-up for stat numbers: <span data-count="100" data-suffix="%"> --- */
  function bindCounts() {
    var els = [].slice.call(document.querySelectorAll('[data-count]:not(.cnt-bound)'));
    if (!els.length) return;
    els.forEach(function (el) { el.classList.add('cnt-bound'); });
    if (reduced || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var target = parseFloat(el.getAttribute('data-count'));
        if (isNaN(target)) return;
        var prefix = el.getAttribute('data-prefix') || '';
        var suffix = el.getAttribute('data-suffix') || '';
        var start = null, dur = 1800;
        function tick(t) {
          if (start === null) start = t;
          var p = Math.min((t - start) / dur, 1);
          var v = Math.round(target * (1 - Math.pow(1 - p, 4)));
          el.textContent = prefix + v + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    splitWords();
    tagZoom();
    bindCounts();

    /* --- scroll reveal --- */
    var els = [].slice.call(document.querySelectorAll('[data-rev]:not(.rev-bound)'));
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('rev-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
      els.forEach(function (el) { el.classList.add('rev-bound'); io.observe(el); });
      /* safety net: if IO is throttled or fails, reveal in-viewport elements periodically */
      var tries = 0;
      var safety = setInterval(function () {
        tries++;
        var pending = document.querySelectorAll('[data-rev]:not(.rev-in)');
        if (!pending.length || tries > 10) { clearInterval(safety); return; }
        pending.forEach(function (el) { if (inViewport(el)) el.classList.add('rev-in'); });
      }, 1500);
      window.addEventListener('scroll', function () {
        document.querySelectorAll('[data-rev]:not(.rev-in)').forEach(function (el) { if (inViewport(el)) el.classList.add('rev-in'); });
      }, { passive: true });
    } else {
      els.forEach(function (el) { el.classList.add('rev-in', 'rev-bound'); });
    }

    /* --- parallax --- */
    var pWraps = [].slice.call(document.querySelectorAll('[data-parallax]:not(.plx-bound)'));
    if (pWraps.length && !reduced) {
      pWraps.forEach(function (w) { w.classList.add('plx-bound'); });
      var imgs = pWraps.map(function (w) { return w.querySelector('img'); }).filter(Boolean);
      var ticking = false;
      var update = function () {
        ticking = false;
        imgs.forEach(function (img) {
          var wrap = img.closest('[data-parallax]');
          var r = wrap.getBoundingClientRect();
          if (r.bottom < -100 || r.top > innerHeight + 100) return;
          var p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
          img.style.transform = 'translateY(' + (p * -7) + '%) scale(1.14)';
        });
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    /* --- before/after drag slider --- */
    [].slice.call(document.querySelectorAll('.ba:not(.ba-bound)')).forEach(function (ba) {
      ba.classList.add('ba-bound');
      var after = ba.querySelector('.ba__after');
      var handle = ba.querySelector('.ba__handle');
      if (!after || !handle) return;
      var set = function (p) {
        p = Math.max(4, Math.min(96, p));
        after.style.clipPath = 'inset(0 0 0 ' + p + '%)';
        handle.style.left = p + '%';
      };
      var fromEvent = function (ev) {
        var r = ba.getBoundingClientRect();
        var x = (ev.touches ? ev.touches[0].clientX : ev.clientX) - r.left;
        set((x / r.width) * 100);
      };
      var drag = false;
      ['mousedown', 'touchstart'].forEach(function (t) { ba.addEventListener(t, function (e) { drag = true; fromEvent(e); }, { passive: true }); });
      ['mousemove', 'touchmove'].forEach(function (t) { window.addEventListener(t, function (e) { if (drag) fromEvent(e); }, { passive: true }); });
      ['mouseup', 'touchend', 'touchcancel'].forEach(function (t) { window.addEventListener(t, function () { drag = false; }, { passive: true }); });
      set(50);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
